import gql from 'graphql-tag';

export const placeCameraFragment = gql`
  fragment placeCameraParts on PlaceCamera {
    cameraId
    name
    cameraType
    channel
    isPrincipal
    forMobile
    isRestricted
    isOnline
    snapshotUrl
    device {
      id
      name
      ip
    }
    deviceType {
      id
      name
    }
  }
`;
